import { render, staticRenderFns } from "./VariacoesForm.vue?vue&type=template&id=47aeffcd&scoped=true&"
import script from "./VariacoesForm.vue?vue&type=script&lang=js&"
export * from "./VariacoesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aeffcd",
  null
  
)

export default component.exports